import { render } from "./EditProcess.vue?vue&type=template&id=f94af412&scoped=true"
import script from "./EditProcess.vue?vue&type=script&lang=js"
export * from "./EditProcess.vue?vue&type=script&lang=js"

import "./EditProcess.vue?vue&type=style&index=0&id=f94af412&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f94af412"]])

export default __exports__